import { Observable, Subject, merge } from 'rxjs';
import { map } from 'rxjs/operators';
import { Guid } from '../../shared/utils/Guid';
import { NotificationType } from '../enums/notification-type.enum';
import { NotificationContentType } from '../enums/notification-content-type.enum';

export class Notification {
  private readonly _message: string;
  private readonly _title: string;
  private readonly _timestamp: Date;
  private readonly _id: Guid;
  private readonly _type: NotificationType;
  private readonly _contentType: NotificationContentType;
  private _externalTap: Observable<void>;
  private readonly _internalTapSource: Subject<void>;

  constructor(
    message: string,
    title: string = null,
    type: NotificationType = NotificationType.Info,
    contentType: NotificationContentType = NotificationContentType.Text
  ) {
    this._message = message;
    this._title = title;
    this._timestamp = new Date(); // Now
    this._id = Guid.create();
    this._type = type;
    this._contentType = contentType;

    this._internalTapSource = new Subject();
  }

  public get id(): Guid {
    return this._id;
  }

  public get message(): string {
    return this._message;
  }

  public get title(): string {
    return this._title;
  }

  public get timestamp(): Date {
    return this._timestamp;
  }

  public get type(): NotificationType {
    return this._type;
  }

  public get contentType(): NotificationContentType {
    return this._contentType;
  }

  public get onTap(): Observable<void> {
    return this._externalTap
      ? merge(this._internalTapSource.asObservable(), this._externalTap)
      : this._internalTapSource.asObservable();
  }

  public registerTapSource(onTap: Observable<any>): void {
    this._externalTap = onTap.pipe(map(() => {}));
  }

  public tap(): void {
    this._internalTapSource.next();
  }
}
